<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div mat-dialog-title class="modal-header">
    <div class="d-flex justify-content-between">
        <span class="ml-3">{{ dialogData.header }}</span>
        <button mat-dialog-close class="close close-btn" type="button"><ds-icon name="close" size="inherit"></ds-icon></button>
    </div>
</div>
<mat-dialog-content>
    <div class="row">
        <div class="col-xs-12">
            <div class="card-layout">
                <form #legAssignmentForm="ngForm">
                    <div class="row">
                        <div *ngIf="!isForRejection" class="col-md-6 form-group">
                            <label
                                >Select Contact Person<span class="text-danger"> * </span>
                                <span *ngIf="memberLoader == true" class="ml-2">
                                    <ds-loading-spinner
                                        class="text-danger"
                                        theme="inherit"
                                        [diameter]="14"
                                        [strokeWidth]="2"
                                    ></ds-loading-spinner>
                                </span>
                            </label>
                            <ngx-select-dropdown
                                id="select_person"
                                #select_person="ngModel"
                                name="select_person"
                                required
                                tabindex="0"
                                [config]="contactConfig"
                                [multiple]="false"
                                [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && select_person.invalid }"
                                [options]="vendorMemberList"
                                [(ngModel)]="selectedMember"
                                (ngModelChange)="getPhoneNumberByMemberId(selectedMember?.memberId)"
                            >
                            </ngx-select-dropdown>
                            <div *ngIf="legAssignmentForm.submitted && select_person.invalid" class="invalid-feedback">
                                <div *ngIf="select_person.errors.required">
                                    <span style="color: red"> Please Select Contact Person.</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!isForRejection" class="col-md-6 form-group">
                            <label
                                >Phone<span class="text-danger"> * </span>
                                <span *ngIf="phoneNumberLoader == true" class="ml-2">
                                    <ds-loading-spinner
                                        class="text-danger"
                                        theme="inherit"
                                        [diameter]="14"
                                        [strokeWidth]="2"
                                    ></ds-loading-spinner>
                                </span>
                            </label>
                            <input class="form-control" disabled type="text" [value]="selectedPhoneNumber | phoneNumberPipe" />
                        </div>
                        <div *ngIf="!isForRejection" class="col-md-12 form-group p-0">
                            <div class="col-md-6">
                                <label>
                                    {{ dialogData.legDetailList[0]?.transportType == 'Air' ? 'Select Aircraft' : 'Select Vehicle'
                                    }}<span class="text-danger"> * </span>
                                    <span *ngIf="vehicleLoader == true" class="ml-2">
                                        <ds-loading-spinner
                                            class="text-danger"
                                            theme="inherit"
                                            [diameter]="14"
                                            [strokeWidth]="2"
                                        ></ds-loading-spinner>
                                    </span>
                                </label>
                                <select
                                    id="vehicleId"
                                    class="form-control"
                                    #vehicle="ngModel"
                                    name="vehicle"
                                    required
                                    [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && vehicle.invalid }"
                                    [(ngModel)]="assignLegPayload.vehicleId"
                                    (ngModelChange)="selectVehicle($event)"
                                >
                                    <option disabled selected [value]="''">
                                        {{ dialogData.legDetailList[0]?.transportType === 'Air' ? 'Select Aircraft' : 'Select Vehicle' }}
                                    </option>
                                    <option *ngFor="let vehicle of vehicleDetailList" [value]="vehicle.vehicleId">
                                        {{ vehicle.vehicleName }}
                                    </option>
                                </select>
                                <div *ngIf="legAssignmentForm.submitted && vehicle.invalid" class="invalid-feedback">
                                    <div *ngIf="vehicle.errors.required">
                                        <span style="color: red">
                                            {{
                                                dialogData.legDetailList[0].transportType == 'Air'
                                                    ? 'Please Select Aircraft'
                                                    : 'Please Select Vehicle'
                                            }}</span
                                        >
                                    </div>
                                </div>
                                <div *ngIf="legAssignmentForm.submitted && assignLegPayload.vehicleId == '0'" class="invalid-feedback">
                                    <span style="color: red">Please Select Aircraft.</span>
                                </div>
                            </div>

                            <div *ngIf="!isForRejection" class="col-md-6">
                                <label
                                    >{{ dialogData.legDetailList[0]?.transportType === 'Air' ? '#Tail Number' : 'Plate Number'
                                    }}<span class="text-danger"> * </span></label
                                >
                                <input class="form-control" disabled type="text" [value]="assignLegPayload.vehicleNumber" />
                            </div>

                            <div class="col-md-12 form-group p-0">
                                <div class="col-md-6">
                                    <label>OB Repo</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="outbound_reposition"
                                        name="outboundReposition"
                                        [settings]="airportCodeDropDownSettings"
                                        [placeholder]="'Select OB Repo'"
                                        [data]="airportCodeList"
                                        [(ngModel)]="selectedOBReposition"
                                    >
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-md-6">
                                    <label>IB Repo</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="inbound_reposition"
                                        name="inboundReposition"
                                        [settings]="airportCodeDropDownSettings"
                                        [placeholder]="'Select IB Repo'"
                                        [data]="airportCodeList"
                                        [(ngModel)]="selectedIBReposition"
                                    >
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                            </div>

                            <div class="col-md-12 form-group p-0">
                                <div class="col-md-3">
                                    <label>OB Est. Block Hours</label>
                                    <input
                                        id="ob_estimated_block_hours"
                                        class="form-control"
                                        appIntegerOnly
                                        name="obEstimatedBlockHours"
                                        placeholder="OutBound Estimated Block Hours"
                                        type="number"
                                        [(ngModel)]="assignLegPayload.obEstimatedBlockHours"
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label>OB Est. Block Minutes</label>
                                    <input
                                        id="ob_estimated_block_minutes"
                                        class="form-control"
                                        #obRepoEstBlockMinutes="ngModel"
                                        appIntegerOnly
                                        name="obEstimatedBlockMinutes"
                                        placeholder="OutBound Estimated Block Minutes"
                                        required
                                        type="number"
                                        [ngClass]="{
                                            'is-invalid': legAssignmentForm.submitted && assignLegPayload.obEstimatedBlockMinutes > 59,
                                        }"
                                        [(ngModel)]="assignLegPayload.obEstimatedBlockMinutes"
                                    />
                                    <span
                                        *ngIf="legAssignmentForm.submitted && assignLegPayload.obEstimatedBlockMinutes > 59"
                                        class="text-danger"
                                    >
                                        Please input valid OB Est. Block Minutes
                                    </span>
                                </div>
                                <div class="col-md-3">
                                    <label>IB Est. Block Hours</label>
                                    <input
                                        id="ib_estimated_block_hours"
                                        class="form-control"
                                        appIntegerOnly
                                        name="ibEstimatedBlockHours"
                                        placeholder="InBound Estimated Block Hours"
                                        type="number"
                                        [(ngModel)]="assignLegPayload.ibEstimatedBlockHours"
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label>IB Est. Block Minutes</label>
                                    <input
                                        id="ib_estimated_block_minutes"
                                        class="form-control"
                                        #ibRepoEstBlockMinutes="ngModel"
                                        appIntegerOnly
                                        name="ibEstimatedBlockMinutes"
                                        placeholder="InBound Estimated Block Minutes"
                                        required
                                        type="number"
                                        [ngClass]="{
                                            'is-invalid': legAssignmentForm.submitted && assignLegPayload.ibEstimatedBlockMinutes > 59,
                                        }"
                                        [(ngModel)]="assignLegPayload.ibEstimatedBlockMinutes"
                                    />
                                    <span
                                        *ngIf="legAssignmentForm.submitted && assignLegPayload.ibEstimatedBlockMinutes > 59"
                                        class="text-danger"
                                    >
                                        Please input valid OB Est. Block Minutes
                                    </span>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngFor="let detail of dialogData.legDetailList">
                            <div class="col-md-6 form-group">
                                <label>Origin</label>
                                <input id="enq_origin" class="form-control" name="origin" readonly type="text" [value]="detail.origin" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Destination</label>
                                <input
                                    id="enq_destination"
                                    class="form-control"
                                    name="destination"
                                    readonly
                                    type="text"
                                    [value]="detail.destination"
                                />
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Pickup Time</label>
                                <div class="datetimepicker endtimeDate">
                                    <input
                                        id="startAssigntime"
                                        class="form-control"
                                        autocomplete="off"
                                        disabled
                                        name="startAssigntime"
                                        type="text"
                                        [value]="detail.plannedPickUpDateTime | localDate"
                                    />
                                    <ds-icon name="calendar_today" size="inherit" class="calendar-icon"></ds-icon>
                                </div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Dropoff Time</label>
                                <div class="datetimepicker endtimeDate">
                                    <input
                                        id="endVendortime"
                                        class="form-control"
                                        autocomplete="off"
                                        disabled
                                        name="endVendortime"
                                        type="text"
                                        [value]="detail.plannedDropOffDateTime | localDate"
                                    />
                                    <ds-icon name="calendar_today" size="inherit" class="calendar-icon"></ds-icon>
                                </div>
                            </div>
                        </ng-container>
                        <div *ngIf="isForRejection" class="col-md-12 form-group">
                            <label>Reason For Rejection <span class="text-danger">*</span></label>
                            <div>
                                <textarea
                                    id="rejectionNote"
                                    class="form-control"
                                    #rejectionNote="ngModel"
                                    autocomplete="off"
                                    name="rejectionNote"
                                    required
                                    rows="2"
                                    [(ngModel)]="rejectionReason"
                                ></textarea>
                                <div *ngIf="legAssignmentForm.submitted && rejectionNote.invalid" class="invalid-feedback">
                                    <div *ngIf="rejectionNote.errors.required">
                                        <span style="color: red"> Please write down the reason for rejection! </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer pr-0 pb-0">
                        <button mat-dialog-close class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" type="button">
                            Cancel
                        </button>
                        <button
                            *ngIf="!isForRejection"
                            class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            type="submit"
                            (click)="assignDriver(legAssignmentForm)"
                        >
                            Assign
                        </button>
                        <button
                            *ngIf="isForRejection"
                            class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            type="submit"
                            (click)="rejectAssignment(legAssignmentForm)"
                        >
                            Reject
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</mat-dialog-content>
